import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	BuiltInBaseEntityState,
	DefinitionEntityState,
	ChangeSet,
	ChangeSetEntityChangeType,
	safeResolveEntityName
} from '@elyx-code/project-logic-tree';
import { findNextAvailableName } from './utils';

export function createDefinitionEntityFromBuiltInBaseEntity(
	from: BuiltInBaseEntityState,
	_connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): DefinitionEntityState {
	const desiredName = safeResolveEntityName(from, project, 'New definition');

	const newName = findNextAvailableName(desiredName, project.entities);

	// Create a new definition entity of this built-in-base-entity at this coordinates
	const newDefinition = from.implement(newName, changeSet);

	if (!!newDefinition) {
		changeSet.add(newDefinition, ChangeSetEntityChangeType.Added);

		return newDefinition as DefinitionEntityState;
	}

	return null;
}
